"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var Clock = function Clock(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M48 88c22.091 0 40-17.909 40-40S70.091 8 48 8 8 25.909 8 48s17.909 40 40 40zm0 8C21.49 96 0 74.51 0 48S21.49 0 48 0s48 21.49 48 48-21.49 48-48 48zm2-48.171V19a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v33h.01l26.426 18.504a2 2 0 0 0 2.786-.491l2.294-3.277a2 2 0 0 0-.491-2.785L50 47.829z",
    fill: "currentColor"
  })));
};
var _default = exports.default = Clock;